import { useDispatch } from "react-redux";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiThatThrows } from "containers/Request";
import { ApiResponse } from "types/api";

import { TiVoAppVariantVersion } from "./types";

export const usePromoteAndPublish = (
  id?: string,
  variantId?: string,
  versionId?: string
) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation<ApiResponse<TiVoAppVariantVersion>, Error, void>({
    mutationFn: async () => {
      return dispatch(
        apiThatThrows.promoteAndPublishTiVoVariantVersion.action({
          params: { id, variantId, versionId },
        })
      );
    },
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: ["variant", id, variantId],
      });
    },
  });
};
